import { useMutation } from '@apollo/client'
import { BookkeepersManagementUpdateIncidenceReadAtDocument } from 'generated/resources/graphql'

interface QueryParameters {
  incidenceId: string
  markAsRead: boolean
}

export const useUpdateIncidenceReadAt = () => {
  const [updateIncidenceReadAt, { loading }] = useMutation(
    BookkeepersManagementUpdateIncidenceReadAtDocument
  )

  return {
    update(params: QueryParameters) {
      return updateIncidenceReadAt({ variables: params })
    },
    loading,
  }
}
